export default __webpack_public_path__ + "static/media/studio2020_4.96c44faa.jpeg";